module.exports = __webpack_public_path__ + "img/VL_20_03.9f6da15e.png";